import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const KalkylatorerIndex = lazy(() => import("@/pages/kalkylatorer/KalkylatorerIndex"));

export const Route = createFileRoute("/kalkylatorer")({
  head: () => seoHead("/kalkylatorer", { description: "Räkna på din investering eller din elräkning innan du bestämmer dig. Här är alla våra kalkylatorer samlade på ett ställe." }),
  component: () => <KalkylatorerIndex />,
});
